module.exports = "/assets/data/9ee707b89ebd3aea55d4c1ed8a03a838-WS5.data.json";